// extracted by mini-css-extract-plugin
export default {"button":"nrm3jn"};